// Static content for the Offerings landing page. Structured so it can later be
// lifted into the CMS. Edit copy, services and links here.

export const WHATSAPP_NUMBER = '46760551806'; // country code + number, no +/spaces
export const SALES_EMAIL = 'sales@voxitconsulting.media';
export const SALES_PHONE = '+260 760930203';

export const OFFERINGS = [
  {
    key: 'bpo',
    icon: 'Headphones',
    headline: 'Managed Customer Support & BPO',
    short:
      'Let Voxit manage part or all of your customer support operation—remotely, on-site, or through a dedicated Voxit support centre.',
    long:
      'We combine trained support teams, proven processes, communication platforms, reporting, automation, and AI to create a reliable customer experience across every channel.',
    savingsLabel: 'Up to 55% lower support running costs',
    cta: 'Improve My Customer Support',
    services: [
      'Complete outsourced customer support',
      'On-site support team',
      'Remote support team',
      'Dedicated support centre',
      'Customer service setup and transformation',
      'Helpdesk and technical support',
      'Telephone and call handling',
      'WhatsApp customer support',
      'Email and chat support',
      'Social media support',
      'Ticketing and CRM platform management',
      'AI-assisted customer service',
      'Quality assurance and performance reporting',
      'Workforce planning and team management',
      'After-hours or overflow support',
    ],
    benefits: [
      'Reduce the cost of running an internal support operation',
      'Improve response times',
      'Give customers a consistent experience',
      'Scale support as the business grows',
      'Gain better reporting and operational control',
      'Access experienced specialists without building everything internally',
    ],
    models: [
      'Monthly managed-service subscription',
      'Dedicated team',
      'On-site delivery',
      'Remote delivery',
      'Hybrid delivery',
      'Individual support consultants',
    ],
  },
  {
    key: 'automation',
    icon: 'Bot',
    headline: 'AI & Business Automation',
    short:
      'Automate repetitive work, connect your systems, and help your employees make faster and better decisions.',
    long:
      'Voxit identifies manual, costly, and time-consuming processes and turns them into efficient digital workflows using automation, system integrations, data, and practical AI.',
    savingsLabel: 'Cut manual admin work by an estimated 30–50%',
    cta: 'Find My Automation Opportunities',
    services: [
      'AI opportunity assessment',
      'Business process analysis',
      'Workflow automation',
      'Customer-service automation',
      'WhatsApp automation',
      'AI chatbots and virtual assistants',
      'Document and data processing',
      'Automated reporting',
      'CRM automation',
      'Sales and lead automation',
      'Finance and administration workflows',
      'Agriculture and farming automation',
      'Inventory and supply-chain automation',
      'System integrations',
      'Custom internal AI tools',
      'Employee AI assistants',
      'Automation maintenance and support',
    ],
    benefits: [
      'Reduce repetitive manual work',
      'Lower administrative costs',
      'Improve speed and accuracy',
      'Reduce human errors',
      'Give employees more time for valuable work',
      'Make better use of existing systems and information',
      'Scale operations without increasing overhead at the same rate',
    ],
    models: [
      'Automation assessment',
      'Single automation project',
      'Pilot project',
      'Ongoing automation programme',
      'AI and automation consultant',
      'Fully managed automation service',
    ],
  },
  {
    key: 'product',
    icon: 'Layers',
    headline: 'Digital Product Development',
    short:
      'From the first idea to launch, maintenance, and support—we take responsibility for the complete product journey.',
    long:
      'Voxit can plan, design, build, launch, maintain, and support digital platforms and services. Clients can engage us for one specialist, a complete project team, or full end-to-end product delivery.',
    savingsLabel: 'One partner from idea to launch and support',
    cta: 'Discuss My Product Idea',
    services: [
      'Business and product discovery',
      'Requirements analysis',
      'Project planning',
      'Budget and cost estimation',
      'Product strategy',
      'Project management',
      'UX and UI design',
      'Website development',
      'Web application development',
      'Mobile application development',
      'Customer portals',
      'Internal business platforms',
      'E-commerce solutions',
      'Agriculture and farming platforms',
      'API and system integration',
      'Testing and quality assurance',
      'Cloud setup and deployment',
      'Cybersecurity support',
      'Product maintenance',
      'Technical support',
      'Continuous product improvement',
    ],
    benefits: [
      'One partner from idea to operation',
      'Faster path from concept to launch',
      'Clear planning, ownership, and cost control',
      'Access to multidisciplinary expertise',
      'Flexible team size',
      'Long-term maintenance and support',
    ],
    models: [
      'Individual consultant',
      'Dedicated development team',
      'Fixed-scope project',
      'Product development partnership',
      'End-to-end managed delivery',
      'Ongoing maintenance subscription',
    ],
  },
];

export const DELIVERY_MODELS = [
  { name: 'Individual consultant', desc: 'One specialist embedded in your team.', best: 'Targeted expertise, fast start' },
  { name: 'Dedicated team', desc: 'A managed team working only for you.', best: 'Sustained delivery & ownership' },
  { name: 'Project delivery', desc: 'A defined scope with a clear outcome.', best: 'A specific, bounded goal' },
  { name: 'Fully managed service', desc: 'We run the whole operation for you.', best: 'Hands-off operations' },
  { name: 'Monthly subscription', desc: 'Ongoing capacity billed monthly.', best: 'Predictable, flexible cost' },
];

export const INDUSTRIES = [
  'Retail', 'Fashion', 'Grocery', 'Automotive', 'Agriculture',
  'Manufacturing', 'Telecommunications', 'Public sector', 'Technology',
];

export const VALUE_POINTS = [
  { icon: 'TrendingDown', title: 'Lower operating costs' },
  { icon: 'Zap', title: 'Faster and more consistent service' },
  { icon: 'Expand', title: 'Scalable teams and technology' },
  { icon: 'Handshake', title: 'One accountable delivery partner' },
];

export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1573164574511-73c773193279?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
  support: 'https://images.pexels.com/photos/8866772/pexels-photo-8866772.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  automation: 'https://images.unsplash.com/photo-1655720357872-ce227e4164ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=940',
  product: 'https://images.unsplash.com/photo-1528901166007-3784c7dd3653?crop=entropy&cs=srgb&fm=jpg&q=85&w=940',
  shop: 'https://images.pexels.com/photos/30848031/pexels-photo-30848031.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  farm: 'https://images.pexels.com/photos/17797257/pexels-photo-17797257.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
};
